import React from "react";
import { IoCheckmarkSharp } from "react-icons/io5";
import "./EAChoiceChip.scss";

interface IProps {
  label: string;
  isSelected: boolean;
  disabled?: boolean;
  size?: "small" | "medium";
  onClick: () => void;
  fullWidth?: boolean;
  showSelectedIcon?: boolean;
  icon?: React.ReactNode;
  showIconWhenSelected?: boolean;
  /** Licznik przy chipie (np. liczba biletów/karnetów wymagających działania klienta). */
  badge?: number;
}

const EAChoiceChip: React.FC<IProps> = ({
  label,
  isSelected,
  disabled,
  size = "medium",
  onClick,
  fullWidth = false,
  showSelectedIcon = true,
  icon,
  showIconWhenSelected = true,
  badge,
}) => {
  // Jeśli mamy ikonę, nie pokazujemy checkmark'a
  const shouldShowCheckmark = isSelected && showSelectedIcon && !icon;
  // Ikonę pokazujemy zawsze, chyba że shouldShowIconWhenSelected jest false
  const shouldShowIcon = icon && showIconWhenSelected;

  return (
    <div
      className={`choice-chip choice-chip--${size} ${isSelected ? "choice-chip--selected" : ""} ${
        fullWidth ? "choice-chip--fullWidth" : ""
      }
      ${disabled ? "choice-chip--disabled" : ""}`}
      onClick={onClick}
    >
      {shouldShowCheckmark && (
        <span className="choice-chip__slot choice-chip__slot--left">
          <span className="choice-chip__icon">
            <IoCheckmarkSharp />
          </span>
        </span>
      )}
      <b className="choice-chip__label">{label}</b>
      {!!badge && <span className="choice-chip__badge">{badge}</span>}
      {shouldShowIcon && (
        <span className="choice-chip__slot choice-chip__slot--right">
          <span className="choice-chip__icon choice-chip__icon--custom">{icon}</span>
        </span>
      )}
    </div>
  );
};

export default EAChoiceChip;
